import {
	AUTH,ROUTES
} from '../constants';
import { redirect } from 'redux-first-router';
import firebaseAdaptor from '../firebaseAdaptor';
import { loadProfile, registProfile, loadProfileForReducer } from './profile';

const firebase = firebaseAdaptor.firebase;

const logoutSucceeded = () => ({
	type: AUTH.LOGGED_OUT
});

const loginSucceed = (user) => ({
	type: AUTH.LOGGED_IN,
	payload: {
		user: user
	}
});

export function loginByGoogle() {
	return (dispatch, getState) => {
		var provider = new firebase.auth.GoogleAuthProvider();
		firebase.auth().signInWithPopup(provider).then(function (result) {
			// This gives you a Google Access Token. You can use it to access the Google API.
			//var token = result.credential.accessToken;
			// The signed-in user info.
			//var user = result.user;
			dispatch(loginSucceed(result.user));
			dispatch(redirect({type:ROUTES.HOME_PAGE}));
			//dispatch()
			// ...
		}).catch(function (error) {
			// Handle Errors here.
			console.log(error);
			// ...
		});
	};

}

export function logout(cbSuccess, cbError) {
	return (dispatch, getState) => {
		firebase.auth().signOut().then(function () {
			dispatch({
				type: AUTH.LOGGED_OUT
			});
			cbSuccess && cbSuccess();
		}).catch(function (error) {
			cbError && cbError(error);
		});
	};
}

export function startAuthListener(store, callbackForRestore, callbackForDestroy) {
	firebase.auth().onAuthStateChanged(function (user) {
		if (user) {
			// User is signed in.
			//var displayName = user.displayName;
			//var email = user.email;
			//var emailVerified = user.emailVerified;
			//var photoURL = user.photoURL;
			//var isAnonymous = user.isAnonymous;
			//var uid = user.uid;
			//var providerData = user.providerData;
			// ...
			const { auth } = store.getState();
			for (const observer in auth.observers) {
				auth.observers[observer] && auth.observers[observer](user);
			}
			store.dispatch(loginSucceed(user));
			store.dispatch(loadProfile((data) => {
				if (!data) {
					store.dispatch(registProfile(() => {
						store.dispatch(loadProfile((data) => {
							store.dispatch(loadProfileForReducer(data));
						}));
					}));
					return;
				}
				store.dispatch(loadProfileForReducer(data));
			}));
			callbackForRestore();
		} else {
			store.dispatch(logoutSucceeded());
			callbackForDestroy && callbackForDestroy();
			// User is signed out.
			// ...
		}
	});
}
